import { openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "jdl-icon-message"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "工单支持", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "sub-title"
}, "提报工单问题解决更快哦～", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_popover = _resolveComponent("el-popover");
  return _openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom",
    width: 200,
    trigger: "click",
    "popper-class": "contact-us"
  }, {
    reference: _withCtx(() => [_ctx.useDefault ? (_openBlock(), _createElementBlock("i", _hoisted_1)) : _renderSlot(_ctx.$slots, "default", {
      key: 1
    })]),
    default: _withCtx(() => [_hoisted_2, _hoisted_3, _createVNode(_component_el_button, {
      class: "button",
      type: "primary",
      onClick: _ctx.handleHandIn
    }, {
      default: _withCtx(() => [_createTextVNode("去提报")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 3
  });
}